import Eventbrite from './Eventbrite';

export default Eventbrite;
